// extracted by mini-css-extract-plugin
module.exports = {"wrapperProgress":"styled_wrapperProgress__2lhxX","levelProgress":"styled_levelProgress__2nbck"};